// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__MBhbb","validationTips":"StatementDescriptor_validationTips__kDOkT"};